import React, { useState } from 'react';
import { Button, Descriptions, Radio } from 'antd';

const DailyTradeDescription = (props) => {


  const {data} = props;
  const profitFactor = data.profitFactor
  ? typeof data.profitFactor === "object"
    ? parseFloat(Number(data.profitFactor["$numberDecimal"]).toFixed(2))
    : parseFloat(Number(data.profitFactor).toFixed(2))
  : 1;


  const items = [
        {
          key: '1',
          label: 'Trades',
          children: data.totalTrades,
          span: {
              sm: 4,
              xl: 2,
              md: 2,
              lg: 3,
            },
        },
        {
          key: '2',
          label: 'Win Rate %',
          children: Number(data.winRate).toFixed(2),
          span: {
              sm: 4,
              xl: 2,
              md: 2,
              lg: 3,
            },
        },
        {
          key: '3',
          label: 'Winners',
          children: data.winners,
          span: {
              sm: 4,
              xl: 2,
              md: 2,
              lg: 3,
            },
        },
        {
          key: '4',
          label: 'Lossers',
          children: data.losers,
          span: {
              sm: 4,
              xl: 2,
              md: 2,
              lg: 3,
            },
        },
        {
          key: '6',
          label: 'Volume',
          children: data.totalVolume,
          span: {
              sm: 4,
              xl: 2,
              md: 2,
              lg: 3,
            },
        },
        {
          key: '7',
          label: 'Profit Factor',
          // children: parseFloat(data.profitFactor? Number(data.profitFactor['$numberDecimal']).toFixed(2) : 1),
          children: profitFactor,

          span: {
              sm: 4,
              xl: 2,
              md: 2,
              lg: 3,
            },
        },
      ];
  return (
    <div>
      <Descriptions
        size='small'
        contentStyle={{fontSize: "12px"}}
        labelStyle={{fontSize: "12px"}}
        items={items}
        bordered
      />
    </div>
  );
};
export default DailyTradeDescription;